import { API_BASE_URL } from './api';

let pendingGuestSession = null;

/**
 * Create or refresh one signed guest identity and share in-flight bootstrap work.
 * This prevents app startup, auth hydration, and the first planner request from
 * racing three guest-session calls with different identities.
 */
export const ensureGuestSession = async ({ force = false, refresh = false } = {}) => {
  if (force) {
    sessionStorage.removeItem('guest_bootstrapped');
    localStorage.removeItem('anon_id');
  }

  const mirroredAnonId = localStorage.getItem('anon_id');
  if (!force && !refresh && sessionStorage.getItem('guest_bootstrapped') && mirroredAnonId) {
    return mirroredAnonId;
  }
  if (pendingGuestSession) return pendingGuestSession;

  const request = (async () => {
    const existingAnonId = localStorage.getItem('anon_id');
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(`${API_BASE_URL}/v1/auth/guest`, {
        method: 'POST',
        credentials: 'include',
        headers: existingAnonId ? { 'X-Anon-Id': existingAnonId } : undefined,
        signal: controller.signal,
      });
      const data = await response.json();
      if (!response.ok || !data?.anon_id) {
        throw new Error('Guest session could not be started.');
      }
      localStorage.setItem('anon_id', data.anon_id);
      sessionStorage.setItem('guest_bootstrapped', '1');
      return data.anon_id;
    } finally {
      window.clearTimeout(timeoutId);
    }
  })();

  pendingGuestSession = request;
  try {
    return await request;
  } finally {
    if (pendingGuestSession === request) pendingGuestSession = null;
  }
};

export const bootstrapGuestSession = () => ensureGuestSession({ refresh: true });
